var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex message-wrapper typing-indicator",
      class: { "typing-indicator--on": _vm.messages.isShowingTypingIndicator },
    },
    [
      _c(
        "div",
        { staticClass: "message-avatar-placeholder" },
        [_c("customer-avatar", { staticClass: "is-small message-avatar" })],
        1
      ),
      _vm._v(" "),
      _vm._m(0),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "message" }, [
      _c("img", {
        staticStyle: { display: "block" },
        attrs: { src: "/typing.svg", alt: "Typing", height: "20" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }